module.exports = __webpack_public_path__ + "media/images/btn_send-8e0e8e0a431acf4b50fedeb4ecc5a820.gif";